module.exports = __webpack_public_path__ + "static/media/send-message.4a98607b.svg";